import { Button, Tooltip } from '@tryhackme/thm-ui-components';
import { TooltipPositionType } from './helper-tooltip.types';
import { StyledHelperToolTipBackButton, StyledHelperToolTipButtonWrapper, StyledHelperToolTipText, StyledHelperToolTipWrapper } from './helper-tooltip.styles';
export const HelperTooltip = ({
  onNextClick,
  onBackClick,
  arrowPosition,
  currentStep,
  maxSteps,
  text,
  ...args
}: TooltipPositionType) => <StyledHelperToolTipWrapper {...args} data-sentry-element="StyledHelperToolTipWrapper" data-sentry-component="HelperTooltip" data-sentry-source-file="helper-tooltip.tsx">
    <Tooltip arrowPosition={arrowPosition} data-sentry-element="Tooltip" data-sentry-source-file="helper-tooltip.tsx">
      <div>
        <StyledHelperToolTipText data-sentry-element="StyledHelperToolTipText" data-sentry-source-file="helper-tooltip.tsx">{text}</StyledHelperToolTipText>
        <StyledHelperToolTipButtonWrapper data-sentry-element="StyledHelperToolTipButtonWrapper" data-sentry-source-file="helper-tooltip.tsx">
          <span>{`${currentStep} of ${maxSteps}`}</span>
          <div>
            {currentStep > 1 && <StyledHelperToolTipBackButton onClick={onBackClick} color="secondary">
                Back
              </StyledHelperToolTipBackButton>}
            <Button onClick={onNextClick} data-sentry-element="Button" data-sentry-source-file="helper-tooltip.tsx">{currentStep === maxSteps ? 'Done' : 'Next'}</Button>
          </div>
        </StyledHelperToolTipButtonWrapper>
      </div>
    </Tooltip>
  </StyledHelperToolTipWrapper>;